module.exports = __webpack_public_path__ + "img/life-ring-1.2236a8c0.jpg";